import api from './api'

export const brandService = {
  getAll: (params?: { search?: string; page?: number; limit?: number }) =>
    api.get('/brands', { params }),

  getById: (id: number) =>
    api.get(`/brands/${id}`),

  create: (data: {
    brand_name: string
    description?: string
    website?: string
    country?: string
  }) => api.post('/brands', data),

  update: (id: number, data: {
    brand_name?: string
    description?: string
    website?: string
    country?: string
  }) => api.put(`/brands/${id}`, data),

  delete: (id: number) =>
    api.delete(`/brands/${id}`),
}
